
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 299 299","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M298.044 255.148c0-7.923-6.433-14.357-14.356-14.357H14.951c-7.923 0-14.356 6.434-14.356 14.357v28.714c0 7.924 6.433 14.357 14.356 14.357h268.737c7.923 0 14.356-6.433 14.356-14.357v-28.714zM298.044 174.828c0-7.924-6.433-14.357-14.356-14.357H14.951c-7.923 0-14.356 6.433-14.356 14.357v28.713c0 7.924 6.433 14.357 14.356 14.357h268.737c7.923 0 14.356-6.433 14.356-14.357v-28.713zM298.044 94.507c0-7.923-6.433-14.357-14.356-14.357H14.951C7.028 80.15.595 86.584.595 94.507v28.714c0 7.924 6.433 14.357 14.356 14.357h268.737c7.923 0 14.356-6.433 14.356-14.357V94.507zM298.044 15.075c0-7.924-6.433-14.357-14.356-14.357H14.951C7.028.718.595 7.151.595 15.075V43.79c0 7.923 6.433 14.357 14.356 14.357h268.737c7.923 0 14.356-6.434 14.356-14.357V15.075z"}})])
          )
        }
      }
    